import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import _ from 'lodash';
import CampaignDashboardHeader from '../../components/campaign-dashboard-header';
import TabActionBar from '../../components/tab-action-bar';
import DataRequestsListing from '../../components/data-requests-listing';
import AudienceDataRequestHandlingModal from '../../components/audience-data-request-handling-modal';

import hasJSONAPIClient from '../../hocs/has-jsonapi-client';
import hasUserInfo from '../../hocs/has-user-info';

import {
  DATA_REQUESTS_RESOURCE,
  ORGANISATION_RESOURCE,
} from '../../utils/helpers/resources';

const STATUS_APPROVED = 'APPROVED';
const STATE_DECLINED = 'DECLINED';

const INITIAL_STATE = {
  isLoading: true,
  isError: false,
  isReviewModalOpen: false,
  selectedRequest: null,
};

class InfluencerRequests extends Component {
  constructor() {
    super();
    this.state = {
      requests: [],
      ...INITIAL_STATE,
    };
  }

  componentDidMount() {
    this.fetchRequests();
  }


  onToggleReviewModalState = () => {
    this.setState(prevState => ({
      isReviewModalOpen: !prevState.isReviewModalOpen,
    }));
  }

  onRequestReviewButtonClick = (event, { id }) => {
    const { requests } = this.state;
    const request = _.find(requests, ['id', id]);
    this.setState({
      isReviewModalOpen: true,
      selectedRequest: request,
    });
  }

  onRequestAccepted = () => {
    this.updateRequestState(STATUS_APPROVED);
  }

  onRequestDeclined = () => {
    this.updateRequestState(STATE_DECLINED);
  }

  fetchRequests = () => {
    const { jsonAPIClient, userInfo } = this.props;
    jsonAPIClient.get(ORGANISATION_RESOURCE, userInfo.organisationId).then(response => {
      const organisation = response.toJSON();
      const influencerId = _.get(organisation, 'influencer.id');
      jsonAPIClient.find(DATA_REQUESTS_RESOURCE, { // eslint-disable-line lodash/prefer-lodash-method
        filter: {
          influencer: influencerId,
        },
        include: ['agency'],
      }).then(resources => {
        const requests = _.map(resources, resource => resource.toJSONTree());
        this.setState({
          requests,
          isLoading: false,
          isError: false,
        });
      });
    });
  }

  updateRequestState = state => {
    const { jsonAPIClient } = this.props;
    const { selectedRequest: { id } } = this.state;
    jsonAPIClient.get(DATA_REQUESTS_RESOURCE, id).then(resource => {
      resource.set('requestStatus', state);
      resource.sync().then(() => {
        this.setState(INITIAL_STATE, this.fetchRequests);
      });
    });
  }

  render() {
    const { isLoading, isError, requests, selectedRequest, isReviewModalOpen } = this.state;
    return (
      <div className="page">
        <CampaignDashboardHeader
          name="My Requests"
        />
        <div className="page-content">
          <TabActionBar
            onViewModeChanged={this.onViewModeChanged}
          />
          <DataRequestsListing
            isInfluencerMode
            isLoading={isLoading}
            isError={isError}
            requests={requests}
            onRequestReviewButtonClick={this.onRequestReviewButtonClick}
          />
          {
            isReviewModalOpen && <AudienceDataRequestHandlingModal
              {...selectedRequest}
              onClose={this.onToggleReviewModalState}
              onRequestAccepted={this.onRequestAccepted}
              onRequestDeclined={this.onRequestDeclined}
            />
          }
        </div>
      </div>
    );
  }
}

InfluencerRequests.propTypes = {
  jsonAPIClient: PropTypes.func.isRequired,
  userInfo: PropTypes.object.isRequired,
};


export default compose(
  hasJSONAPIClient,
  hasUserInfo,
)(InfluencerRequests);



/** WEBPACK FOOTER **
 ** ./src/containers/influencer-requests/index.js
 **/